var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsNew(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_42180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6296 8.19727H5.92593C2.66667 8.19727 0 10.8639 0 14.1232V23.9997C0 27.259 2.66667 29.9257 5.92593 29.9257H8.88889C9.97531 29.9257 10.8642 30.8146 10.8642 31.901V32.7899C10.8642 35.0615 13.284 36.4442 15.2593 35.3578L24.2963 30.3207C24.7407 30.0738 25.2346 29.9257 25.7284 29.9257H29.6296C32.8889 29.9257 35.5556 27.259 35.5556 23.9997V14.1232C35.5556 10.8639 32.8889 8.19727 29.6296 8.19727ZM9.87654 21.5306C8.79012 21.5306 7.90124 20.6417 7.90124 19.5553C7.90124 18.4689 8.79012 17.58 9.87654 17.58C10.963 17.58 11.8519 18.4689 11.8519 19.5553C11.8519 20.6417 10.963 21.5306 9.87654 21.5306ZM17.7778 21.5306C16.6914 21.5306 15.8025 20.6417 15.8025 19.5553C15.8025 18.4689 16.6914 17.58 17.7778 17.58C18.8642 17.58 19.7531 18.4689 19.7531 19.5553C19.7531 20.6417 18.8642 21.5306 17.7778 21.5306ZM25.679 21.5306C24.5926 21.5306 23.7037 20.6417 23.7037 19.5553C23.7037 18.4689 24.5926 17.58 25.679 17.58C26.7654 17.58 27.6543 18.4689 27.6543 19.5553C27.6543 20.6417 26.7654 21.5306 25.679 21.5306Z",
    fill: "#686DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0741 16.0989C37.3469 16.0989 40 13.4458 40 10.173C40 6.9002 37.3469 4.24707 34.0741 4.24707C30.8013 4.24707 28.1482 6.9002 28.1482 10.173C28.1482 13.4458 30.8013 16.0989 34.0741 16.0989Z",
    fill: "#00E7CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_42180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNew);
export default __webpack_public_path__ + "static/media/smsNew.28f301990eed908d75cccb86c6235300.svg";
export { ForwardRef as ReactComponent };